import KgXhrClass from './kg-xhr'

export default class TgCertMgrCtrlClass {
  constructor(_conf) {
    this.kg = new KgXhrClass(
      'TGCertMgrCtrl',
      '0DADE507-64D6-4306-956A-2ED144FF0ED1',
      'G7Fhvhm9'
    )

    // this.kg
    //   .init()
    //   .then(() => {})
    //   .catch((err) => {
    //     return Promise.reject(err)
    //   })
  }

  getCertInfo(certB64, type) {
    return this.kg.invoke('getCertInfo', certB64, type)
  }

  getCertList(filterCondition) {
    return this.kg.invoke('getCertList', filterCondition)
  }

  getCertListEx(filterCondition) {
    return this.kg.invoke('getCertListEx', filterCondition)
  }

  selectCert(filterCondition) {
    return this.kg.invoke('selectCert', filterCondition)
  }

  GetLastError() {
    return this.kg.invoke('GetLastError')
  }

  getAllUkeySerialNum() {
    return this.kg.invoke('getAllUkeySerialNum')
  }

  importCFCACert(uKeyNum, CertPwd, certB64) {
    return this.kg.invoke('importCFCACert', uKeyNum, CertPwd, certB64)
  }

  uKeyUnlocked(uKeyNum, adminPin, newPin) {
    return this.kg.invoke('uKeyUnlocked', uKeyNum, adminPin, newPin)
  }

  SetDllName(dllName, dllType, addMethod) {
    return this.kg.invoke('SetDllName', dllName, dllType, addMethod)
  }

  SetContent(certSN, title, content, rights, isDelExist) {
    return this.kg.invoke(
      'SetContent',
      certSN,
      title,
      content,
      rights,
      isDelExist
    )
  }

  GetContent(certSN, title) {
    return this.kg.invoke('GetContent', certSN, title)
  }

  DeleteContent(certSN, title) {
    return this.kg.invoke('DeleteContent', certSN, title)
  }

  VerifyPin(certSN, pin) {
    return this.kg.invoke('VerifyPin', certSN, pin)
  }

  SignData(certSN, originalB64, signType, hashOid) {
    return this.kg.invoke('SignData', certSN, originalB64, signType, hashOid)
  }

  VerifyData(signCertB64, signType, originalB64, signValueB64, hashOid) {
    return this.kg.invoke(
      'VerifyData',
      signCertB64,
      signType,
      originalB64,
      signValueB64,
      hashOid
    )
  }

  SetAsynchronous(funcName, isAsyn) {
    return this.kg.invoke('SetAsynchronous', funcName, isAsyn)
  }

  GetErrorMsg(errorCode) {
    return this.kg.invoke('GetErrorMsg', errorCode)
  }

  SetLanguage(languageType) {
    return this.kg.invoke('SetLanguage', languageType)
  }

  UkeyUnlockedEx(certSN, adminPin, newUserPin) {
    return this.kg.invoke('UkeyUnlockedEx', certSN, adminPin, newUserPin)
  }

  UkeyChangePin(certSN, oldPin, newPin) {
    return this.kg.invoke('UkeyChangePin', certSN, oldPin, newPin)
  }

  SetMakeCertServer(pid, psec, host, port, serverType) {
    return this.kg.invoke(
      'SetMakeCertServer',
      pid,
      psec,
      host,
      port,
      serverType
    )
  }

  SetMakeCertUkeyDrive(dllName, cspName, supportMulti) {
    return this.kg.invoke(
      'SetMakeCertUkeyDrive',
      dllName,
      cspName,
      supportMulti
    )
  }

  MakeCert(certApplyInfo) {
    return this.kg.invoke('MakeCert', certApplyInfo)
  }

  PubKeyEncrypt(certB64, plainTextB64) {
    return this.kg.invoke('PubKeyEncrypt', certB64, plainTextB64)
  }

  PriKeyDecrypt(cipherTextB64) {
    return this.kg.invoke('PriKeyDecrypt', cipherTextB64)
  }

  PriKeyDecryptEx(
    certB64,
    pubKeyEncCipherB64,
    symmKeyCipherB64,
    symmAlgOid,
    symmMode,
    initVecB64
  ) {
    return this.kg.invoke(
      'PriKeyDecryptEx',
      certB64,
      pubKeyEncCipherB64,
      symmKeyCipherB64,
      symmAlgOid,
      symmMode,
      initVecB64
    )
  }

  SymmEncryptByKeyCipher(
    certB64,
    pubKeyEncCipherB64,
    plainTextB64,
    symmAlgOid,
    symmMode,
    initVecB64
  ) {
    return this.kg.invoke(
      'SymmEncryptByKeyCipher',
      certB64,
      pubKeyEncCipherB64,
      plainTextB64,
      symmAlgOid,
      symmMode,
      initVecB64
    )
  }

  SymmEncrypt(symmKeyB64, plainTextB64, symmAlgOid, symmMode, initVecB64) {
    return this.kg.invoke(
      'SymmEncrypt',
      symmKeyB64,
      plainTextB64,
      symmAlgOid,
      symmMode,
      initVecB64
    )
  }

  SymmDecrypt(symmKeyB64, cipherTextB64, symmAlgOid, symmMode, initVecB64) {
    return this.kg.invoke(
      'SymmDecrypt',
      symmKeyB64,
      cipherTextB64,
      symmAlgOid,
      symmMode,
      initVecB64
    )
  }

  EncryptFile(
    srcFile,
    dstFile,
    certB64List,
    symmAlgOid,
    symmMode,
    initVecB64,
    formatVersion
  ) {
    return this.kg.invoke(
      'EncryptFile',
      srcFile,
      dstFile,
      certB64List,
      symmAlgOid,
      symmMode,
      initVecB64,
      formatVersion
    )
  }

  DecryptFile(srcFile, dstFile) {
    return this.kg.invoke('DecryptFile', srcFile, dstFile)
  }

  ShowCert(certB64) {
    return this.kg.invoke('ShowCert', certB64)
  }

  GetVersionInfo() {
    return this.kg.invoke('GetVersionInfo')
  }

  CheckCert(certB64, host, port, serverType) {
    return this.kg.invoke('CheckCert', certB64, host, port, serverType)
  }

  DecryptDigitalEnvelope(digitalEnvelopeB64) {
    return this.kg.invoke('DecryptDigitalEnvelope', digitalEnvelopeB64)
  }

  GenCSR(
    bstrUkeySN,
    lCertAlg,
    lCertBitLen,
    bstrKeyPairType,
    bstrCertDN,
    lReGenKeyPair,
    bstrPin
  ) {
    return this.kg.invoke(
      'GenCSR',
      bstrUkeySN,
      lCertAlg,
      lCertBitLen,
      bstrKeyPairType,
      bstrCertDN,
      lReGenKeyPair,
      bstrPin
    )
  }

  ImportCertAndKeyPair(
    bstrSignCertB64,
    bstrEncCertB64,
    bstrKeyPairB64,
    bstrSymmAlg,
    bstrSymmCipherB64,
    bstrAuthCode,
    lSingleCert
  ) {
    return this.kg.invoke(
      'ImportCertAndKeyPair',
      bstrSignCertB64,
      bstrEncCertB64,
      bstrKeyPairB64,
      bstrSymmAlg,
      bstrSymmCipherB64,
      bstrAuthCode,
      lSingleCert
    )
  }

  EncryptFileEx(srcFile, dstFile, encParam) {
    return this.kg.invoke('EncryptFileEx', srcFile, dstFile, encParam)
  }

  DecryptFileEx(srcFile, decParam) {
    return this.kg.invoke('DecryptFileEx', srcFile, decParam)
  }

  GetEncryptFileInfo(encFile, infoID) {
    return this.kg.invoke('GetEncryptFileInfo', encFile, infoID)
  }

  InitServer(serverInfo) {
    return this.kg.invoke('InitServer', serverInfo)
  }

  Login(userInfo) {
    return this.kg.invoke('Login', userInfo)
  }

  GetLoginState() {
    return this.kg.invoke('GetLoginState')
  }

  Logout() {
    return this.kg.invoke('Logout')
  }

  LoginAuthCode(authCode) {
    return this.kg.invoke('LoginAuthCode', authCode)
  }

  openBrowser(sUrl, sExtData) {
    return this.kg.invoke('openBrowser', sUrl, sExtData)
  }

  closeBrowser() {
    return this.kg.invoke('closeBrowser')
  }

  UploadFileToServer(serverUrl, filePath, fileForm, extraParam) {
    return this.kg.invoke(
      'UploadFileToServer',
      serverUrl,
      filePath,
      fileForm,
      extraParam
    )
  }

  DownloadFile(url, filePath, extraParam) {
    return this.kg.invoke('DownloadFile', url, filePath, extraParam)
  }

  GetNetworkToken() {
    return this.kg.invoke('GetNetworkToken')
  }

  TGGetSystemTempPath() {
    return this.kg.invoke('TGGetSystemTempPath')
  }

  TG_SetConfig(config) {
    return this.kg.invoke('TG_SetConfig', config)
  }

  GetFrontConfigInfo() {
    return this.kg.invoke('GetFrontConfigInfo')
  }

  GetCurrentCertInfo() {
    return this.kg.invoke('GetCurrentCertInfo')
  }

  SetCurrentCertInfo(certInfo) {
    return this.kg.invoke('SetCurrentCertInfo', certInfo)
  }

  ChangePin(certSN) {
    return this.kg.invoke('ChangePin', certSN)
  }

  UkeyUnlockedExWithAuthCode(certSN, authCode, accountUUID, newUserPin) {
    return this.kg.invoke(
      'UkeyUnlockedExWithAuthCode',
      certSN,
      authCode,
      accountUUID,
      newUserPin
    )
  }

  TGOpenSelectFileDialog(sFilter) {
    return this.kg.invoke('TGOpenSelectFileDialog', sFilter)
  }

  SetIsUseCachePin(isUseCachePin) {
    return this.kg.invoke('SetIsUseCachePin', isUseCachePin)
  }

  GetIsUseCachePin() {
    return this.kg.invoke('GetIsUseCachePin')
  }

  OpenLicenseDlg(type) {
    return this.kg.invoke('OpenLicenseDlg', type)
  }

  TG_SetUserData(key, value, overwrite) {
    return this.kg.invoke('TG_SetUserData', key, value, overwrite)
  }

  TG_GetUserData(key, isDelete) {
    return this.kg.invoke('TG_GetUserData', key, isDelete)
  }

  TGIsFileExist(sFilePath) {
    return this.kg.invoke('TGIsFileExist', sFilePath)
  }

  TGSaveFileDialog(sFilter, type) {
    return this.kg.invoke('TGSaveFileDialog', sFilter, type)
  }

  TG_OESFackFunction(type) {
    return this.kg.invoke('TG_OESFackFunction', type)
  }

  CheckAnke(dllName, cspName) {
    return this.kg.invoke('CheckAnke', dllName, cspName)
  }

  QueryOrganizeCodeByCertSn(certSN) {
    return this.kg.invoke('QueryOrganizeCodeByCertSn', certSN)
  }

  TG_GetFileType(filePath) {
    return this.kg.invoke('TG_GetFileType', filePath)
  }

  TG_MobileShieldSign(signParam) {
    return this.kg.invoke('TG_MobileShieldSign', signParam)
  }

  TG_EncryptData(inDataB64, encParam) {
    return this.kg.invoke('TG_EncryptData', inDataB64, encParam)
  }

  TG_DecryptData(digitalEnvelopeB64) {
    return this.kg.invoke('TG_DecryptData', digitalEnvelopeB64)
  }

  TG_GenCSREx(
    bstrUkeySN,
    lCertAlg,
    lCertBitLen,
    bstrKeyPairType,
    bstrCertDN,
    lReGenKeyPair,
    bstrPin,
    adminPin,
    bstrCtrlInfo
  ) {
    return this.kg.invoke(
      'TG_GenCSREx',
      bstrUkeySN,
      lCertAlg,
      lCertBitLen,
      bstrKeyPairType,
      bstrCertDN,
      lReGenKeyPair,
      bstrPin,
      adminPin,
      bstrCtrlInfo
    )
  }

  TG_RestartApp(appID) {
    return this.kg.invoke('TG_RestartApp', appID)
  }

  TGServerForward(jsonParam) {
    return this.kg.invoke('TGServerForward', jsonParam)
  }

  TG_GetSystemInfo() {
    return this.kg.invoke('TG_GetSystemInfo')
  }

  TG_GetConfig(sSection, sKey) {
    return this.kg.invoke('TG_GetConfig', sSection, sKey)
  }

  TG_GetThirdSealInfo(type, certSN) {
    return this.kg.invoke('TG_GetThirdSealInfo', type, certSN)
  }

  TG_SetZhuTongClientCode(clientCode) {
    return this.kg.invoke('TG_SetZhuTongClientCode', clientCode)
  }

  TG_GetFileHash(filePath, hashName) {
    return this.kg.invoke('TG_GetFileHash', filePath, hashName)
  }

  TG_UploadFrontBuryData(sBuryData) {
    return this.kg.invoke('TG_UploadFrontBuryData', sBuryData)
  }

  TG_GetBIDSealInfo(sJsonParam) {
    return this.kg.invoke('TG_GetBIDSealInfo', sJsonParam)
  }

  TG_MobileShieldBIDFileSign(signParam) {
    return this.kg.invoke('TG_MobileShieldBIDFileSign', signParam)
  }

  TG_DecryptDataEx(digitalEnvelopeB64, symKeyB64) {
    return this.kg.invoke('TG_DecryptDataEx', digitalEnvelopeB64, symKeyB64)
  }

  TG_GetSealList(jsonParam) {
    return this.kg.invoke('TG_GetSealList', jsonParam)
  }

  TG_GetCAProviderList(extInfo) {
    return this.kg.invoke('TG_GetCAProviderList', extInfo)
  }

  TG_InitCAPlugin(jsonParam) {
    return this.kg.invoke('TG_InitCAPlugin', jsonParam)
  }

  TG_GetCertList(jsonParam) {
    return this.kg.invoke('TG_GetCertList', jsonParam)
  }

  TG_SignData(jsonParam) {
    return this.kg.invoke('TG_SignData', jsonParam)
  }

  TG_CancelSign(jsonParam) {
    return this.kg.invoke('TG_CancelSign', jsonParam)
  }

  TG_GetCertStatus(jsonParam) {
    return this.kg.invoke('TG_GetCertStatus', jsonParam)
  }

  TG_GetSealStatus(jsonParam) {
    return this.kg.invoke('TG_GetSealStatus', jsonParam)
  }

  TG_GetTimeStamp() {
    return this.kg.invoke('TG_GetTimeStamp')
  }

  TG_SetCAUserData(jsonParam) {
    return this.kg.invoke('TG_SetCAUserData', jsonParam)
  }

  TG_GetCAUserData(jsonParam) {
    return this.kg.invoke('TG_GetCAUserData', jsonParam)
  }
}
